document.addEventListener( 'click', e => {

    const btn = e.target.closest( '.js-copy-link' );
    if( !btn ) return;

    e.preventDefault();

    navigator.clipboard.writeText( btn.dataset.copy ).then( () => {
        btn.classList.add( 'copied' );
        setTimeout( () => btn.classList.remove( 'copied' ), 2000 );
    });

});
